import { useState, useEffect } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';
import '../styles/MessageModal.css';

export default function AdminNoteModal({ isOpen, onClose, onNoteAdded }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setContent('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!content.trim()) {
      return;
    }

    try {
      setLoading(true);
      await axios.post('/admin-notes', { content: content.trim() });
      setContent('');
      onNoteAdded();
      onClose();
    } catch (error) {
      console.error('Error creating note:', error);
      alert('Nie udało się dodać notatki. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="message-modal-overlay" onClick={onClose}>
      <div className="message-modal" onClick={(e) => e.stopPropagation()}>
        <div className="message-modal-header">
          <h2>Dodaj notatkę</h2>
          <button onClick={onClose} className="message-modal-close">
            <X size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Treść notatki</label>
            <textarea
              className="form-input"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Wpisz treść notatki..."
              rows={6}
              required
            />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="button-secondary">
              Anuluj
            </button>
            <button type="submit" className="button-primary" disabled={loading}>
              {loading ? 'Zapisywanie...' : 'Dodaj'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

